/**
 * The values in the cases are deprecated -> https://en.wikipedia.org/wiki/List_of_tz_database_time_zones,
 * and as such, the library used for the timestamp doesn't recognize them -> date-fns-tz.
 * @param deprecatedValue
 * @returns {string}
 */
/* istanbul ignore next */
export const transformDeprecatedTimezones = deprecatedValue => {
  switch (deprecatedValue) {
    case 'US/Eastern':
      return 'America/New_York';
    case 'US/Alaska':
      return 'America/Anchorage';
    case 'US/Aleutian':
      return 'America/Adak';
    case 'US/Arizona':
      return 'America/Phoenix';
    case 'US/Central':
      return 'America/Chicago';
    case 'US/East-Indiana':
      return 'America/Indiana/Indianapolis';
    case 'US/Hawaii':
      return 'Pacific/Honolulu';
    case 'US/Indiana-Starke':
      return 'America/Indiana/Knox';
    case 'US/Michigan':
      return 'America/Detroit';
    case 'US/Mountain':
      return 'America/Denver';
    case 'US/Pacific':
      return 'America/Los_Angeles';
    case 'US/Pacific-New':
      return 'America/Los_Angeles';
    case 'US/Samoa':
      return 'Pacific/Pago_Pago';
    default:
      return deprecatedValue;
  }
};
